export default __webpack_public_path__ + "static/media/TopL_Green.c6d2dad0.png";